__turbopack_context__.v({
  "deliveryMethodRadioGroup": "_3rGCCa_deliveryMethodRadioGroup",
  "noDelivery": "_3rGCCa_noDelivery",
  "title": "_3rGCCa_title",
  "wrapper": "_3rGCCa_wrapper",
});
